import React from 'react'
import { Link } from 'react-router-dom'

function CardItem(props) {
  return (
    <>
        <li className='cards__item'>
            <Link className='cards__item__link' to={props.path}>
                <figure className='cards__item__pic-wrap' data-category={props.label}>
                    <img src={props.src} alt='Card'
                    className='cards__item__img'/>
                </figure>
                <div className='cards__item__info'>
                    <h4 className='cards__item__label'>{props.label}</h4>
                    {/* keep description hidden by default; available if needed */}
                    <h5 className='cards__item__text' style={{display: 'none'}}>{props.text}</h5>
                </div>
            </Link>
        </li>
    </>
  )
}

export default CardItem
